import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';

import {ApiService} from '../../shared/api-service.service'

import {Router} from '@angular/router';


declare var paypal;

@Component({
  selector: 'app-pay-page',
  templateUrl: './pay-page.component.html',
  styleUrls: ['./pay-page.component.css']
})
export class PayPageComponent implements OnInit {

  leadData:any = {}
  clientSideKey:String = "AbGoAPD1b2IbNO1DzUveYJ0GkulMjcPoLaIiWXsKT0l69WeMh9UIgfgXUQzCnHPvc7Mzn3DDAqTFcLTl"
  userFirstName:String = ""
  details:String = ""

  @ViewChild('firstNameLabel',{static:true}) private firstNameLabel;
  @ViewChild('paypal',{static:true})  paypalRef : ElementRef;

  product = {
    price: 25,
    desription: "application fee",
  }

  paidFor:boolean = true
  wasError:boolean = false
  constructor( private router: Router, private cloudService: ApiService ) { }

  ngOnInit() {
    this.loadUserData()
    paypal.Buttons({
      createOrder: (data, actions) => {
        return actions.order.create({
          purchase_units : [
            {
              description:this.product.desription,
              amount: {
                currency_code: 'USD',
                value: this.product.price
              }
            }
          ],
          application_context: {shipping_preference: 'NO_SHIPPING'}
        })
      },
      onApprove: async (data, actions) => {
        const order = await actions.order.capture()
        this.paidFor = true
        this.confimration()      
      },
      onError: err => {
        console.log("error was thrown by paypal")
        this.wasError=true
      }

    }).render(this.paypalRef.nativeElement)
  }

  loadUserData(){
    this.leadData = JSON.parse(localStorage.getItem("leadData"))
    console.log(this.leadData)
    this.userFirstName = this.leadData.first_name
    if(this.leadData.maritalStatus == "married"){
      this.product = {
        price: 50,
        desription: "application fee",
      }
    }
    this.formatDetailsStr()
  }

  formatDetailsStr(){
    if(this.leadData.maritalStatus == "married"){
      this.details = "As a married applicant, your review is estimated at $50."
    }else if(this.leadData.maritalStatus == "unmarried"){
      this.details = "As an unmarried applicant, your review is estimated at $25."
    }else{
      this.details = "As a seperated applicant, your review is estimated at $25."
    }
  }

  confimration(){
    console.log("should have routed");
   
    this.cloudService.cloudPost(JSON.stringify(this.leadData)).subscribe(packet => {
      console.log("packet?" + packet)
    });
    console.log("called post")
    this.router.navigate(['confirmation']);
  }

  //TODO: clear local storage after final http request

}
